import { createSelector } from 'reselect';
import { appState } from './utils';
import { translator } from 'mage-i18n';

import { getSelectedCountryKey, getCurrentRegion, getSelectedPartnerKey } from './data';

const partnersNameSpace = createSelector(appState, ({ partners }) => partners);

export const getAllPartners = createSelector(partnersNameSpace, data => {
  return data;
});

export const _getPartners = createSelector(appState, ({ partners = {} }) => partners.elements);

export const getSupportedCountries = country =>
  createSelector(getAllPartners, (partners = []) =>
    partners.some(partner => partner.supportedCountries.includes(country)),
  );

export const getPartners = createSelector(_getPartners, translator, (partners = [], t) =>
  partners.map(({ ...p }) => ({
    ...p,
    key: p.id,
    label: t(`products-fe.partners.${p.id}`, {}, p.name),
  })),
);

export const getStandardPartners = createSelector(
  getPartners,
  getSelectedCountryKey,
  getCurrentRegion,
  (partners = [], countryKey, region) => {
    // render US platforms as default for us region
    if (region === 'us' && !['US', 'CA', 'MX'].includes(countryKey)) {
      countryKey = 'US';
    }
    const partnersPerCountry = partners.filter(partner =>
      (partner.supportedCountries || []).includes(countryKey),
    );
    return partnersPerCountry;
  },
);

export const getSelectedPartner = createSelector(
  getSelectedPartnerKey,
  getPartners,
  (id, partners) => partners.find(p => p.id === id),
);
